export default __webpack_public_path__ + "static/media/courses-create-1.4bb57056.jpg";